import { AxiosClient } from "./AxiosClient";

export const login = (email, password) => {
  try {
    return AxiosClient.post("auth/login", { email, password });
  } catch (e) {
    console.log(e);
  }
};

export const createPin = (token) => {
  try {
    return AxiosClient.post("auth/createPin", { token });
  } catch (e) {
    console.log(e);
  }
};

export const validatePin = (token, pin) => {
  try {
    return AxiosClient.post("auth/validatePin", { token, pin });
  } catch (e) {
    console.log(e);
  }
};

export const getUserFirstLast = () => {
  try {
    return AxiosClient.get("feed/getUserFirstLast");
  } catch (e) {
    console.log(e);
  }
};

export const getLightDarkMode = () => {
  try {
    return AxiosClient.get("settings/getLightDarkMode");
  } catch (e) {
    console.log(e);
  }
};

export const updateLightDarkMode = (dark_mode) => {
  try {
    return AxiosClient.post("settings/updateLightDarkMode", { dark_mode });
  } catch (e) {
    console.log(e);
  }
};
